module.exports = __webpack_public_path__ + "img/Rhonda_Morris@2x.c36aad0b.webp";